import { render, staticRenderFns } from "./PaymentSuperTable.vue?vue&type=template&id=c82d2f28"
import script from "./PaymentSuperTable.vue?vue&type=script&lang=js"
export * from "./PaymentSuperTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports